import React from 'react'

/**
 * Returns true if the window width is greater than or equal to the breakpoint
 * @param breakpoint - The breakpoint to check against
 * @returns True if the window width is greater than or equal to the breakpoint, false otherwise
 */
export function useWindowWidth(breakpoint: number): boolean {
  const [isAboveBreakpoint, setIsAboveBreakpoint] = React.useState(window.innerWidth >= breakpoint)

  React.useEffect(() => {
    const handleResize = () => {
      setIsAboveBreakpoint(window.innerWidth >= breakpoint)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isAboveBreakpoint
}
